module.exports = __webpack_public_path__ + "img/hr-tree-05-b-trunk.1ef89fc3.png";